const VCDA = 'VCDA';
const VEHICLES = 'VEHICLES';
const WIS = 'WIS';
export const MEDIA = 'MEDIA';
export const VDP_LINK = 'VDP_LINK';

const NOT_FOUND = 'NOT_FOUND';
const FETCH_ERROR = 'FETCH_ERROR';

export const NR_PREFIX = 'AMP_OFFER';
export const VEHICLES_FETCH_NOT_FOUND = `${VCDA}/${VEHICLES}/${NOT_FOUND}`;
export const VEHICLES_FETCH_ERROR = `${VCDA}/${VEHICLES}/${FETCH_ERROR}`;
export const VDP_LINK_FETCH_ERROR = `${WIS}/${VDP_LINK}/${FETCH_ERROR}`;
export const VDP_LINK_FETCH_NOT_FOUND = `${WIS}/${VDP_LINK}/${NOT_FOUND}`;
export const MEDIA_NOT_FOUND = `${VCDA}/${MEDIA}/${NOT_FOUND}`;
export const MEDIA_FETCH_ERROR = `${VCDA}/${MEDIA}/${FETCH_ERROR}`;

// Error types
export const GENERIC_ERROR = 'GENERIC_ERROR';
export const AMP_VEHICLE_OUT_OF_STOCK = 'AMP_VEHICLE_OUT_OF_STOCK';
export const EXPIRED_OFFER = 'EXPIRED_OFFER';
export const INVALID_OFFER = 'INVALID_OFFER';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
